import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControlLabel, Checkbox } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "./loading";
import Error from "./Error";
import { addUserPermission, getUserError, getUserLoading, getUserRestaurants, getUserStatus, getUserSuccess, selectUserRestaurants, updateStatus } from "../features/userSlice";
import { toast } from "react-toastify";

const RestaurantPermissions = ({ open, handleClose, userName, userId }) => {
    const dispatch = useDispatch();
    const [localRestaurants, setLocalRestaurants] = useState([]);
    const [selected, setSelected] = useState([]);
    const status = useSelector(getUserStatus);
    const error = useSelector(getUserError);
    const success = useSelector(getUserSuccess);
    const loading = useSelector(getUserLoading);
    const userRestaurants = useSelector(selectUserRestaurants);

    useEffect(() => {
        if (open) {
            setSelected([]);
            dispatch(getUserRestaurants(userId));
        }
    }, [open, dispatch, userId]);


    useEffect(() => {
        if (status === "fetchUserRestaurantsSuccess") {
            setLocalRestaurants(userRestaurants);
        }
    }, [userRestaurants, status]);

    useEffect(() => {
        if (status === "addUserPermissionSuccess") {
            toast.success(success);
            handleClose()
            dispatch(updateStatus());
        } else if (status === "addUserPermissionError") {
            toast.error(error);
        }
    }, [status, error, success, handleClose, dispatch]);

    const toggleSelect = (res) => {
        const id = res.restaurantId;

        setSelected((prev) => {
            if (prev.includes(id)) {
                return prev.filter((x) => x !== id);
            }
            return [...prev, id];
        });
    };


    const onSave = () => {
        dispatch(addUserPermission({ userId: userId, body: selected }));
    }

    return (
        <Dialog open={open} onClose={handleClose} fullWidth>
            <DialogTitle>Activer les notifications pour « {userName} » concernant les restaurants disponibles</DialogTitle>
            <DialogContent dividers>
                {status === "loadingUserRestaurants" ? (
                    <Loading size={8} />
                ) : status === "fetchUserRestaurantsError" ? (
                    <Error>{error}</Error>
                ) : (
                    <>
                        {localRestaurants.map((res) => {
                            const isChecked = selected.includes(res.restaurantId)
                                ? !res.notificationsEnabled
                                : res.notificationsEnabled;

                            return (
                                <FormControlLabel
                                    key={res.restaurantId}
                                    control={
                                        <Checkbox
                                            checked={isChecked}
                                            onChange={() => toggleSelect(res)}
                                            color={isChecked ? "success" : "default"}
                                        />
                                    }
                                    label={res.name}
                                    sx={{ display: "flex", alignItems: "center", mb: 1 }}
                                />
                            );
                        })}

                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="error"
                    style={{ color: "white" }}
                    onClick={handleClose}
                >
                    Annuler
                </Button>
                <Button
                    onClick={() => onSave(selected)}
                    variant="contained"
                    color="success"
                    disabled={loading || selected.length === 0}
                >
                    {loading ? <Loading size={8} /> : "Enregistrer"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RestaurantPermissions;
